import Header from "components/Common/Header/Header";
import WeightBody from "components/PatientManagement/Vital/Weight/WeightBody";
import React, { useEffect } from "react";

const Weight = () => {
  useEffect(() => {
    document.title = "Vitals | Weight";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <WeightBody />
    </main>
  );
};

export default Weight;
